import { Button } from '@bambi/component-library/src/components/Button/Button';

import { useAppDispatch, useAppSelector } from 'src/app/store/hooks';

import { onStartAssignmentClone } from '../assignmentManagement.slice';

export function CloneAssignmentAction({ className }: { className?: string }) {
  const dispatch = useAppDispatch();
  const assignment = useAppSelector(
    (state) => state.assignmentManagement.selectedAssignment
  );
  return (
    <Button
      className={`${className}`}
      onClick={() => {
        if (!assignment) {
          return;
        }
        dispatch(onStartAssignmentClone(assignment));
      }}
      disabled={!assignment}
      data-testid="edit-assignment-clone-action"
    >
      Clone Crew Schedule
    </Button>
  );
}
